module.exports = __webpack_public_path__ + "img/19_16.ed8ab5f4.png";